'use client';

import Script from 'next/script';
import { useContext, useEffect, useMemo } from 'react';
import { FirmSettingsContext } from '@/_contexts/FirmSettingsProvider';
import { UserContext } from '@/_contexts/UserProvider';

export const TrengoScript = () => {
  const { preferences } = useContext(FirmSettingsContext);
  const { isAdvisor } = useContext(UserContext);

  const enabled: boolean = useMemo(() => {
    // Show only for clients (not advisors), when a key is present, and no submitted questionnaire found
    return Boolean(!isAdvisor && preferences?.trengo_widget_key);
  }, [isAdvisor, preferences?.trengo_widget_key]);

  // Ensure widget is torn down if it was shown and later must be hidden
  useEffect(() => {
    if (enabled) return;
    // Remove injected scripts and widget containers if present
    const cleanup = () => {
      try {
        const script1 = document.getElementById('trengo-widget');
        const script2 = document.getElementById('trengo-widget-key');
        script1?.parentNode?.removeChild(script1);
        script2?.parentNode?.removeChild(script2);
        const container = document.getElementById(
          'trengo-web-widget-container',
        );
        const iframe = document.getElementById('trengo-web-widget');
        container?.parentNode?.removeChild(container);
        iframe?.parentNode?.removeChild(iframe);
        // Clear global to avoid rehydration from previous state
        // @ts-expect-error - Trengo is provided by the external script
        if (typeof window !== 'undefined' && window.Trengo) {
          // @ts-expect-error
          delete window.Trengo;
        }
      } catch {
        // no-op
      }
    };
    cleanup();
  }, [enabled]);

  if (!enabled) return null;

  return (
    <>
      <Script id="trengo-widget-key" strategy="afterInteractive">
        {`
window.Trengo = window.Trengo || {};
window.Trengo.key = '${preferences?.trengo_widget_key}';
window.Trengo.extraOffsetY = '60px';
        `}
      </Script>
      <Script
        id="trengo-widget"
        src="https://static.widget.trengo.eu/embed.js"
        strategy="afterInteractive"
      />
    </>
  );
};
